import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { ViewCard } from 'apps/dashboard/card/scripts/components';
import { Content, Layout } from 'apps/dashboard/shared/scripts/components';
import { PageLoader } from 'apps/shared/scripts/components';
import { useIsCardDelivered, useOnError } from 'apps/shared/scripts/hooks';

import CardDeliveryFormContainer from '../CardDeliveryFormContainer';

import messages from './messages.json';

const CardDeliveryContainer = () => {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('rd');
  const { cardId } = useParams();
  const { onError } = useOnError();
  const { isDelivered, isLoading } = useIsCardDelivered({
    id: cardId!,
    onError,
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isDelivered) {
      navigate(`/dashboard/cards/${cardId}`, { replace: true });
    }
    // eslint-disable: allow success screen to appear after a delivery event
  }, [isLoading]); // eslint-disable-line

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <Layout>
      <Content
        backTo={redirect ? `/dashboard/cards/${cardId!}?rd=1` : undefined}
        rightHeader={<ViewCard cardId={cardId!} />}
        title={messages.cardDeliveryTitle}
      >
        <CardDeliveryFormContainer cardId={cardId!} />
      </Content>
    </Layout>
  );
};

CardDeliveryContainer.displayName = 'CardDeliveryContainer';

export default CardDeliveryContainer;
